<div *ngIf="customSQLQuery">
  <h1>Edit Custom SQL Query</h1>
  <div class="inline">
    <span class="text-large inline">{{customSQLQuery.name}}  </span>
  </div>
  <br />

  <app-monaco-editor #monaco
    (textChange)="monacoData = $event"
    [editorData]="monacoData"
    [lang]="'sql'"
    [editAccess]="checkAccess(['LOSTalker.Admin'])">
  </app-monaco-editor>

  <br />
  <button matButton="elevated" (click)="goBack()">Go Back</button>
  <button matButton="elevated" *ngIf="checkAccess(['LOSTalker.Admin'])" [disabled]="savingInformation" (click)="updateCustomQuery()">Save Changes</button>
  <app-lt-button *ngIf="checkAccess(['LOSTalker.Admin'])" [disabled]="savingInformation" style="float:right; background-color: #d40404; color: #FFFFFF" (click)="deleteCustomQuery()" label="Delete"></app-lt-button>
  <br />
  <br />
</div>

<app-lt-page-loading-message
  [loading]="pageLoading"
  [loadingFailed]="!pageLoading && !customSQLQuery"></app-lt-page-loading-message>
